/**
 * Set each sign-in provider up so that one of them failing costs only itself.
 *
 * Apple, Facebook and Google used to be initialised by one straight run of
 * statements. With no Apple client id configured,
 * `AppleID.auth.init({clientId: undefined})` throws "The \"clientId\" should be
 * a string.", and that took the whole of init() with it: the Google message and
 * storage listeners were never registered and `googleLoading` was left at its
 * initial `true`, so the "Sign in with Google" button sat in a spinner for
 * ever, with nothing on screen saying why. The page could not be signed into
 * with the provider that WAS configured.
 *
 * Locally that is `.env.local` carrying none of the provider ids, but the
 * coupling would do the same in any environment where one provider is
 * misconfigured, which is the reason this is a fix and not a local workaround.
 *
 * Steps run in order and each is awaited, because the Apple listeners have to
 * be attached after its SDK is fetched. The failures are returned rather than
 * thrown so the caller can decide what to say; nothing here writes to the page.
 *
 * Pure, and in its own file, so it can be unit tested: useSocialLogin.js
 * imports `#app`, which a vitest run cannot resolve.
 */
export async function initProvidersIndependently(steps) {
  const failed = [];
  for (const [name, step] of steps ?? []) {
    try {
      await step();
    } catch (e) {
      failed.push(name);
      console.error(`social sign-in: ${name} could not be set up`, e);
    }
  }
  return {failed};
}
